import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { classNames } from "@/utils/classNames";

/** Outbox source scope (PREC-3850): all leads, chat-only (no campaign), or campaign leads. */
export type OutboxSource = "all" | "chat" | "campaign";

export const OUTBOX_SOURCES: OutboxSource[] = ["all", "chat", "campaign"];

interface OutboxSourceToggleProps {
	source: OutboxSource;
	onSourceChange: (source: OutboxSource) => void;
}

/** Segmented All / Chat / Campaign toggle in the Outbox filter bar. */
export const OutboxSourceToggle: FunctionComponent<OutboxSourceToggleProps> = ({
	source,
	onSourceChange,
}) => {
	const { t } = useTranslation();

	return (
		<div className="flex bg-gray-100 rounded-lg p-[3px] gap-0.5" data-testid="outbox-source-toggle">
			{OUTBOX_SOURCES.map((value) => (
				<button
					key={value}
					className={classNames(
						"px-2.5 py-1 rounded-md text-xs font-semibold whitespace-nowrap cursor-pointer transition-colors",
						source === value ? "bg-white text-text shadow-sm" : "text-text-meta hover:text-text"
					)}
					data-testid={`outbox-source-${value}`}
					type="button"
					onClick={() => onSourceChange(value)}
				>
					{t(`outbox.filters.source.${value}`)}
				</button>
			))}
		</div>
	);
};
